import { isDevelopment, isProduction } from 'helpers/utils/environment';

export const LOG_PREFIX = '[NIKON INTERACTIVE MODEL]';

/**
 * Logs a message only in development mode
 */
export function logMessage(message: string, ...args: any[]): void {
  if (isDevelopment()) {
    console.log(`${LOG_PREFIX}:: ${message}`, ...args);
  }
}

/**
 * Logs an error in all environments
 * Uses only console.error to prevent disruption in production
 */
export function logError(message: string, error?: any): void {
  // Always log to console, but keep it minimal in production
  if (isProduction()) {
    console.error(`${LOG_PREFIX}:: ${message}`);
  } else {
    console.error(`${LOG_PREFIX}:: ${message}`, error);
  }
}